import { useAppStore } from '@src/shared/zustand/store';

export const setFooterHeight = (value: number) =>
  useAppStore.setState({ footerHeight: value });
